import { render } from "./GamePredictions.vue?vue&type=template&id=9560a08a&scoped=true"
import script from "./GamePredictions.vue?vue&type=script&lang=js"
export * from "./GamePredictions.vue?vue&type=script&lang=js"

import "./GamePredictions.vue?vue&type=style&index=0&id=9560a08a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9560a08a"]])

export default __exports__